module.exports = __webpack_public_path__ + "img/Raising Staff.791b43b3.svg";